import { ReviewProps } from '../dto/components/reviewDTO';

import emoji1 from '~/assets/images/emoji1.png';
import emoji2 from '~/assets/images/emoji2.png';
import emoji3 from '~/assets/images/emoji3.png';

const reviews: ReviewProps[] = [ {
  stars: 5,
  emoji: emoji1,
  name: 'Emma B.',
  message: '<b>Investing in real stocks</b> while in high school <b>is amazing</b>. The quizzes are super helpful!',
}, {
  stars: 5,
  emoji: emoji2,
  name: 'Dana R.',
  message: 'Thanks to Birdwingo, my kids are discussing ETFs! They’re learning to understand <b>the value of money</b>, and that’s priceless.',
}, {
  stars: 5,
  emoji: emoji3,
  name: 'Natalia S.',
  message: "The <b>step-by-step learning</b> on Birdwingo is <b>incredible</b>. It feels good to understand what you're doing. I've even mastered ETFs. Thumbs up!",
} ];

export default reviews;
